import React, { useEffect, useState } from 'react';
import { LinearProgress, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { getFetch } from '../../../../../fetch/fetch';
import { dateToDateString } from '../../etc/etcfunctions';

const CoachReport: React.FC<any> = (props) => {

    const [unit, setUnit] = useState(undefined);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
    const [disabled, setDisabled] = useState(true);
    const [disabled2, setDisabled2] = useState(true);
    const [users, setUsers] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [index, setIndex] = useState(0);
    const [src, setSrc] = useState("");
    const [studentName, setStudentName] = useState("");
    const [teacherName, setTeacherName] = useState("");
    const [createdAtDate, setCreatedAtDate] = useState("");

    const [isNotReady, setIsNotReady] = useState(true);

    const handleChange = (e: any) => {

        setSelectedUser(null);
        setIndex(0);
        setUnit(e.target.value);


        if (e.target.value === "total") {
            setIsNotReady(false);
        } else {
            setIsNotReady(true);
        }


        if (users && e.target.value === "teacher") {
            const newUsers = users.filter((each: any) => {
                return (
                    (each.value === "teacher" || each.value === "staff")
                )
            })
            setFilteredUsers([...newUsers]);
        }

        if (users && e.target.value === "student") {
            const newUsers = users.filter((each: any) => {
                return (
                    (each.value === "student")
                )
            })
            setFilteredUsers([...newUsers]);
        }

        if (users && e.target.value === "total") {
            const newUsers = users.filter((each: any) => {
                return (
                    (each.value === "nothing")
                )
            })
            setFilteredUsers([...newUsers]);
        }

    }

    const onchange = (e: any, value: any) => {

        if (!value) {
            setSelectedUser(null);
            return;
        }

        setIndex(0);

        setSelectedUser(value);
    }

    const plus = () => {

        setIndex((prevIndex) => {
            if (prevIndex < 0) return 0; // Prevent negative index
            return prevIndex + 1;
        });

    }

    const minus = () => {

        setIndex((prevIndex) => {
            if (prevIndex <= 0) return 0; // Prevent negative index
            return prevIndex - 1;
        });

    }

    const search = async () => {

        try {

            if (!unit) {
                console.log("Please select a unit.");
                return;
            }

            if (!selectedUser && unit !== "total") {
                console.log("Please select a user.");
                return;
            }

            setSubmitLoading(true);

            const result: any = await getFetch(`/dashboard/mycoach/viewreport?unit=${unit}&userId=${selectedUser ? selectedUser.id : ""}&page=${index}`);

            console.log("Search result:", result);

            const data = result.data;

            if (result.message === "success") {
                setSrc(data.src);
                setStudentName(data.studentName);
                setTeacherName(data.teacherName);

                const date = new Date(data.createdAt);
                const dateString = dateToDateString(date);
                setCreatedAtDate(dateString);

            }

            setSubmitLoading(false);

        } catch (e) {
            console.error("Error during search:", e);
        }

    }

    useEffect(() => {

        async function start() {
            var token = "";
            if (window.electron) {
                token = await window.electron.sendMessageApi.getToken();
            }

            setLoading(true);

            fetch("https://peetsunbae.com/dashboard/chart/users", {
                method: "GET",
                headers: { "Authorization": token },
                credentials: "include",
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {

                        const rows: any = [];
                        result.data.forEach((each: any, index: number) => {
                            var data: any = {};
                            data.id = each.id;
                            data.label = each.name;
                            data.phoneNumber = each.phoneNumber;
                            data.value = each.value;
                            data.key = index;
                            rows.push(data);
                        })
                        setUsers([...rows]);
                        setLoading(false);

                    })
            })
        }

        start();

    }, []);

    useEffect(() => {

        var disabled = true;

        if (unit === "total") {
            disabled = false;
        }

        if (unit === "student" || unit === "teacher") {
            if (selectedUser && selectedUser.value) {
                disabled = false;
            }
        }

        setDisabled(disabled);

    }, [unit, selectedUser]);

    useEffect(() => {

        search();

    }, [index, unit, selectedUser]);



    return (
        <div>
            <div>
                {
                    (props.user && (props.user.value === "staff" || props.user.value === "teacher")) &&
                    <>
                        <div style={{
                            display: "flex",
                        }}>
                            <div style={{
                                width: "150px"
                            }}>
                                <Box sx={{
                                    minWidth: "150px",
                                    height: "56px"
                                }}>
                                    <FormControl fullWidth>
                                        <Select
                                            sx={{ backgroundColor: "white" }}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={unit}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="student">학생별</MenuItem>
                                            <MenuItem value="teacher">담임별</MenuItem>
                                            <MenuItem value="total">전체</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div>
                            <div style={{
                                marginLeft: "20px",
                            }}>
                                <Autocomplete
                                    onChange={onchange}
                                    disablePortal
                                    id="combo-box-demo"
                                    options={filteredUsers}
                                    // ref={autoC}
                                    sx={{ width: "150px", backgroundColor: "white" }}
                                    renderInput={(params) => <TextField {...params}
                                        placeholder='이름' />}
                                    disabled={!isNotReady}
                                    fullWidth
                                    value={selectedUser}
                                />
                            </div>
                            {/* <div style={{
                                marginLeft: "20px",
                            }}>
                                <Button
                                    sx={{
                                        width: "80px",
                                        height: "56px",
                                        color: "black",
                                        border: "1px solid rgb(180, 180, 180)",
                                        fontFamily: "Apple_B"
                                    }}
                                    onClick={search}
                                    variant="outlined"
                                    disabled={disabled}
                                >검색</Button>
                            </div> */}
                        </div>
                        <div style={{
                            display: "flex",
                            marginTop: "20px",
                        }}>
                            <div>
                                <Box>
                                    <Button onClick={minus} sx={{ minWidth: "56px", height: "56px", border: "1px solid #cfcfcf", color: "#6b6b6b", fontFamily: "Apple_R", backgroundColor: "white" }} variant="outlined"
                                disabled={index <= 0 || submitLoading}
                                    ><img src="img/chevron-left.svg" alt="left"></img></Button>
                                </Box>
                            </div>
                            <div>
                                <Box>
                                    <Button onClick={plus} sx={{ minWidth: "56px", height: "56px", marginLeft: "7px", border: "1px solid #cfcfcf", color: "#6b6b6b", fontFamily: "Apple_R", backgroundColor: "white" }} variant="outlined"><img src="img/chevron-right.svg" alt="right"></img></Button>
                                </Box>
                            </div>
                        </div>
                    </>
                }
            </div>
            <div style={{
                width: "1200px",
                marginTop: "30px"
            }}>
                {
                    src
                        ?
                        <div style={{
                            width : "100%"
                        }}>
                            <div style={{
                                fontFamily : "Apple_B",
                                fontSize : "20px",
                                marginBottom : "20px",
                            }}>
                                {studentName} 학생 - {teacherName} 코치 ({createdAtDate})
                            </div>
                            <img src={
                                `https://peetsunbae.com/avatartodo/${src}`
                            } alt="report" style={{ width: "100%", height: "100%" }} />
                        </div>

                        :
                        ""
                }

            </div>
        </div>
    )

}

export default CoachReport;